import axiosClient from './axiosClient';
import { UserType } from 'store/userSlice';
import { getCompanyDepartments } from './departmentAPI';

export interface Company {
  id: number;
  name: string;
  created_at: string;
}

export interface CreateCompanyPayload {
  name: string;
}

export interface UpdateCompanyPayload {
  name: string;
}

// Get all companies
export const getCompanies = async (params?: {
  skip?: number;
  limit?: number;
}): Promise<Company[]> => {
  const response = await axiosClient.get('/companies/', {
    params: {
      skip: params?.skip || 0,
      limit: params?.limit || 100
    }
  });
  return response.data;
};

// Get company by ID
export const getCompanyById = async (companyId: number): Promise<Company> => {
  const response = await axiosClient.get(`/companies/${companyId}`);
  return response.data;
};

// Create new company
export const createCompany = async (
  companyData: CreateCompanyPayload
): Promise<Company> => {
  const response = await axiosClient.post('/companies/', companyData);
  return response.data;
};

// Update company
export const updateCompany = async (
  companyId: number,
  companyData: UpdateCompanyPayload
): Promise<Company> => {
  const response = await axiosClient.put(
    `/companies/${companyId}`,
    companyData
  );
  return response.data;
};

// Delete company
export const deleteCompany = async (companyId: number): Promise<string> => {
  const response = await axiosClient.delete(`/companies/${companyId}`);
  return response.data;
};

// Get company users
export const getCompanyUsers = async (
  companyId: number
): Promise<UserType[]> => {
  const response = await axiosClient.get(`/companies/${companyId}/users`);
  return response.data;
};

// Check if company has departments before deletion
export const checkCompanyHasDepartments = async (
  companyId: number
): Promise<boolean> => {
  try {
    const departments = await getCompanyDepartments(companyId);
    return departments.length > 0;
  } catch (error) {
    console.error('Error checking company departments:', error);
    return false;
  }
};
